import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import {
    Grid, Paper, ButtonGroup, IconButton, Button, Tooltip, Box, Typography
} from '@mui/material';

import Slider from '@mui/material/Slider';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import FastForwardIcon from '@mui/icons-material/FastForward';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import StopIcon from '@mui/icons-material/Stop';


import { setNeedBounding, setCenter } from '../../features/map/mapSlice';
import { setTrackPlayerIndex } from '../../features/datacenter/historySlice';


const TrackPlayer = ({ reportID }) => {
    const dispatch = useDispatch();

    const trackData = useSelector(state => state.history.trackData[reportID]);
    const track = trackData && trackData.track;


    const sliderMax = track && track.length - 1;

    const [playState, setPlayState] = useState(false);
    const [playSpeed, setPlaySpeed] = useState(1);
    const [trackIndex, setTrackIndex] = useState(0);

    useEffect(() => {
        const plv = setInterval(() => {
            if (playState) {
                let currposition = Math.min(trackIndex + playSpeed, sliderMax);
                for (let i = 0; i < trackData.stops.length; i++) {
                    if (currposition >= trackData.stops[i].startIndex && currposition <= trackData.stops[i].endIndex) {
                        currposition = trackData.stops[i].endIndex;
                        break;
                    }
                }
                setTrackIndex(currposition);
                dispatch(setTrackPlayerIndex(currposition));
                if (window.googlemap && window.google) {
                    const position = new window.google.maps.LatLng(track[currposition].lat, track[currposition].lng);
                    if (!window.googlemap.getBounds().contains(position)) {
                        window.googlemap.panTo(position);
                    }

                }
                if (currposition === sliderMax) {
                    setPlayState(false);
                }
            }
        }, 500);
        return () => {
            clearInterval(plv);
        }
    }, [dispatch, playState, playSpeed, track, sliderMax, trackIndex, trackData])


    const playToggle = () => {
        //console.log("Track", trackData);
        setPlayState(!playState);
    }

    const resetTrackPosition = () => {
        setPlayState(false);
        setTrackIndex(0);
    }

    const increasePlaySpeed = () => {
        setPlaySpeed(playSpeed * 2 < 129 ? playSpeed * 2 : 128);
    }

    const resetPlaySpeed = () => {
        setPlaySpeed(1);
    }

    const sliderOnchange = (event, currposition) => {
        setTrackIndex(currposition);
        dispatch(setTrackPlayerIndex(currposition));
        if (window.googlemap && window.google) {
            window.googlemap.panTo(new window.google.maps.LatLng(track[currposition].lat, track[currposition].lng,));
        }
        dispatch(setCenter({ lat: track[currposition].lat, lng: track[currposition].lng }));
    };

    const sliderValueFormat = (value) => {
        return (
            <Typography variant="subtitle2">
                {moment(track[value].dt_tracker).add(330, 'minutes').format('D/M/Y h:mm:ss A')}
            </Typography>
        );
    }

    const ValueLabelComponent = (props) => {
        const { children, open, value } = props;
        return (
            <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
                {children}
            </Tooltip>
        )
    }

    if (track) {
        if (track.length > 1) {
            return (
                <Paper>
                    <Grid
                        container
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        alignContent="center"
                        wrap='wrap'
                        spacing={1}
                        style={{
                            marginLeft: '10px',
                            marginBottom: '10px',
                            width: '70vw',
                        }}
                    >
                        <Grid item sm={3}>
                            <ButtonGroup size="small">

                                <IconButton onClick={playToggle} size="large">
                                    {
                                        playState ? <PauseIcon color="primary" /> : <PlayArrowIcon color="primary" />
                                    }
                                </IconButton>

                                <Button size="small" variant="text" endIcon={<FastForwardIcon />} onClick={increasePlaySpeed}>
                                    <span style={{ color: 'Navy' }}>
                                        {`+${playSpeed}`}
                                    </span>
                                </Button>
                                {
                                    playSpeed > 1 &&
                                    <IconButton onClick={resetPlaySpeed} size="large">
                                        <RotateLeftIcon color="primary" />
                                    </IconButton>
                                }
                                <IconButton onClick={resetTrackPosition} size="large">
                                    <StopIcon color="secondary" />
                                </IconButton>
                                <IconButton onClick={() => dispatch(setNeedBounding(true))} size="large">
                                    <ZoomOutMapIcon color="primary" />
                                </IconButton>
                            </ButtonGroup>
                        </Grid>
                        <Grid item sm={9}>
                            <Box width="90%">
                                <Slider
                                    valueLabelFormat={sliderValueFormat}
                                    valueLabelDisplay="auto"
                                    onChange={sliderOnchange}
                                    value={trackIndex}
                                    min={0}
                                    max={sliderMax}
                                    ValueLabelComponent={ValueLabelComponent}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            );
        } else {
            //console.log("Track issue", track);
            return null;
        }
    } else {
        return null;
    }


}

export default TrackPlayer;